import { render, staticRenderFns } from "./laravel-certificate.vue?vue&type=template&id=8a5c3098&"
import script from "./laravel-certificate.vue?vue&type=script&lang=js&"
export * from "./laravel-certificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports